'use client';
import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { CatHeading } from '@blocks-react/components/Heading';
import { useMyEquipmentDrawer } from 'components/my-equipment/my-equipment-drawer-context';
import { CatButton } from '@blocks-react/components/Button';
import { NO_EXACT_MATCH_IMAGE } from 'constants/common';
import { Image } from 'components/image';
import cx from 'classnames';
import styles from '../search-no-equipment/SearchNoEquipment.module.scss';

export const SearchNoEquipment = () => {
  const t = useTranslations();
  const { addEquipmentDrawer } = useMyEquipmentDrawer();
  const openAddEquipmentDrawer = useCallback(
    () => addEquipmentDrawer.openDrawer(),
    [addEquipmentDrawer]
  );

  return (
    <div
      className={cx(
        `d-flex flex-column align-items-center ${styles['no_equipment_container']}`
      )}
      data-testid="add-equipment-drawer"
    >
      <div className={`d-flex flex-column align-items-center`}>
        <Image
          alt={NO_EXACT_MATCH_IMAGE.alt}
          src={NO_EXACT_MATCH_IMAGE.src}
          width={240}
          height={160}
          loading="lazy"
          className={styles['no_equipment_container_no_result_image']}
        />
        <CatHeading variant="label-lg">
          <div
            className={`mt-3 ${styles['no_equipment_container__no_result_text']}`}
          >
            {t('NO_RESULTS_FOUND')}
          </div>
        </CatHeading>
        <CatHeading variant="body">
          <div
            className={cx(
              `mt-2 mb-2 ${styles['no_equipment_container__text_suggestion']}`
            )}
          >
            {t('ENTRY_DOES_NOT_MATCH_EQUIPMENT')}
          </div>
        </CatHeading>
        <CatButton
          variant="ghost"
          onClick={openAddEquipmentDrawer}
          aria-label={`${t('MEQ_ADD_EQUIP')} link`}
        >
          {t('MEQ_ADD_EQUIP')}
        </CatButton>
      </div>
    </div>
  );
};
